import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';
const StoreContext = createContext(null);
export const StoreProvider = ({ children, store }) => {
    return h(StoreContext.Provider, { value: store }, children);
};
export const useStore = () => useContext(StoreContext);
export function withStore(Component) {
    return ((props) => (
    // additional props must come after store prop
    h(Component, { store: useStore(), ...props })));
}
